import { getApiUrl } from '../../../common/utils';
import * as ans from '@wix/answers-api';
import Axios from 'axios';

const apiPath = getApiUrl;
const sourceType: ans.SourceType = ans.SourceType.HELP_CENTER;
const sourceId = null;
const httpPost = Axios.post;

export const resultClickMore = (text: string = '', locale: string) => {
  ans.AnalyticsLogger.logSearchResultClickMore(
    httpPost,
    apiPath,
    locale,
    sourceType,
    sourceId,
    text,
  );
};

export const resultIgnored = (text: string, locale: string) => {
  ans.AnalyticsLogger.logSearchResultIgnored(
    httpPost,
    apiPath,
    locale,
    sourceType,
    sourceId,
    text,
  );
};

export const resultNone = (text: string = '', locale: string) => {
  ans.AnalyticsLogger.logSearchResultNone(
    httpPost,
    apiPath,
    locale,
    sourceType,
    sourceId,
    text,
  );
};

export const resultArticleClicked = (
  text: string,
  articleId: string,
  position: number,
  locale: string,
) => {
  ans.AnalyticsLogger.logSearchResultArticleClicked(
    httpPost,
    apiPath,
    locale,
    sourceType,
    sourceId,
    text,
    articleId,
    position,
  );
};
